module.exports = __webpack_public_path__ + "static/img/6.eea2dc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msbl/6.jpg
// module id = L/7o
// module chunks = 1